import styled from 'styled-components';

export const GoogleLogin = styled.section`
  align-items: center;
  display: flex;
  height: auto;
  justify-content: center;
  margin-top: 0.6em;
`;

export default GoogleLogin;
